<!--MAP, L'ID SERT A ATTACHER L'OBJET MAP DANS LE TS A L'ELEMENT HTML -->
<div  class="map-container height-100">
  <div class="height-100" id="map">
    <!-- AFFICHER SI AUCUNE COORDONNEES -->
      <div *ngIf="!CoordAdressIsFind" class="no-map">
        <p class="margin-2"><i class="far fa-times-circle fa-6x"></i></p>
        <h3>Aucune donnée pour charger la carte</h3>
    </div>
  </div>
</div>
